import React from 'react';
import { useIntl } from 'react-intl';
import toast from 'react-hot-toast';
import styles from './styles.module.css';

export function InAppBrowserBanner() {
	const intl = useIntl();

	const handleCopyLink = async () => {
		try {
			await navigator.clipboard.writeText(window.location.href);
			toast.success(
				intl.formatMessage({ id: 'InAppBrowserBannerCopySuccess' }),
			);
		} catch {
			const input = document.createElement('input');
			input.value = window.location.href;
			document.body.appendChild(input);
			input.select();
			document.execCommand('copy');
			document.body.removeChild(input);
			toast.success(
				intl.formatMessage({ id: 'InAppBrowserBannerCopySuccess' }),
			);
		}
	};

	return (
		<div className={styles.banner} role='alert'>
			<p className={styles.title}>
				{intl.formatMessage({ id: 'InAppBrowserBannerTitle' })}
			</p>
			<p className={styles.message}>
				{intl.formatMessage({ id: 'InAppBrowserBannerMessage' })}
			</p>
			<div className={styles.actions}>
				<button
					type='button'
					className={styles.copyButton}
					onClick={handleCopyLink}
				>
					{intl.formatMessage({ id: 'InAppBrowserBannerCopyLink' })}
				</button>
				<a
					href={window.location.href}
					target='_blank'
					rel='noopener noreferrer'
					className={styles.openLink}
				>
					{intl.formatMessage({ id: 'InAppBrowserBannerOpenInBrowser' })}
				</a>
			</div>
		</div>
	);
}
